import posthog from "posthog-js";

import { posthogEnabled } from "./enabled";
import { registerEnvironmentSuperProperty } from "./register-environment";

const isLocalSession =
    import.meta.env.VITE_ENVIRONMENT?.trim() === "local" ||
    ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

/**
 * PostHog init — import as early as possible (see index.jsx).
 * Skipped when posthogEnabled is false so local bugs can't flood the project.
 */
if (posthogEnabled) {
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        // Ingestion is reversed-proxied through api_host, so we need to explicitly set the UI host to posthog
        ui_host: "https://us.posthog.com",
        // SPA navigations won't fire $pageview without history_change.
        capture_pageview: "history_change",
        // Manual events only for now — autocapture is too noisy.
        autocapture: false,
        // Free tier has limited budget for session replays; skip any sessions created while developing
        disable_session_recording: isLocalSession,
        // Pass through the current environment to PostHog - this allows flags to be targeted to specific environments
        evaluation_contexts: [import.meta.env.VITE_ENVIRONMENT],
    });

    registerEnvironmentSuperProperty();
}
